module.exports = __webpack_public_path__ + "static/media/cube-icon.1e2ae5ea.svg";